import { render, staticRenderFns } from "./ScheduledCampaignsList.vue?vue&type=template&id=452b5c2f&"
import script from "./ScheduledCampaignsList.vue?vue&type=script&lang=js&"
export * from "./ScheduledCampaignsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports